import {
  Box,
  Button,
  Checkbox,
  Divider,
  InputAdornment,
  List,
  ListItem,
  makeStyles,
  Popover,
  Typography,
} from "@material-ui/core";
import React, { useRef } from "react";
import InputTextField from "../../input/inputTextField";
import { Search as SearchIcon } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import DefaultImg from "../../../assets/img/img-default.png";

const useStyle = makeStyles((theme) => ({
  button: {
    padding: 0,
    minWidth: 0,
  },
  perfectScrollBar: {
    height: 200,
  },
  list: {
    paddingTop: 3,
    paddingBottom: 3,
    display: "flex",
    width: "100%",
  },
  listImage: {
    width: 36,
    minWidth: 36,
    display: "flex",
    alignItems: "center",
  },
  name: {
    fontWeight: 500,
    maxWidth: 220,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  attributeText: {
    color: "#b2b2b2",
    fontSize: 12,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 220,
  },
}));

export default function ProductSelectPopoverComponent({
  open,
  anchorEl,
  handleClose,
  id,
  style,
  searchable,
  handleSearch,
  placeholder,
  items,
  isFetching,
  emptyMessage,
  handleChange,
  anchorOrigin,
  transformOrigin,
  PaperProps,
  selectedValue,
  value,
  popoverWidth,
}) {
  const classes = useStyle();
  const textRef = useRef();

  return (
    <Popover
      id={id}
      open={open}
      style={style}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      elevation={2}
      PaperProps={{
        style: { minWidth: "20em" },
        ...PaperProps,
      }}
    >
      {searchable && (
        <Box>
          <InputTextField
            variant="filled"
            size="small"
            fullWidth
            inputRef={textRef}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" style={{ paddingRight: 6 }}>
                  <Button
                    onClick={() => handleSearch(textRef.current.value)}
                    className={classes.button}
                  >
                    <SearchIcon />
                  </Button>
                </InputAdornment>
              ),
              style: {
                backgroundColor: "#fff",
                paddingRight: 0,
              },
            }}
            inputProps={{
              onChange: () => {
                handleSearch(textRef.current.value);
              },
              style: {
                padding: 8,
              },
            }}
            placeholder={placeholder}
          />
        </Box>
      )}
      <Divider />
      <Box style={{ maxHeight: "250px", overflow: "auto" }}>
        {isFetching ? (
          <>
            <Skeleton variant="text" animation="wave" height={25} />
            <Skeleton variant="text" animation="wave" height={25} />
            <Skeleton variant="text" animation="wave" height={25} />
            <Skeleton variant="text" animation="wave" height={25} />
          </>
        ) : items.length > 0 ? (
          <List>
            {items.map((item, index) => (
              <ListItem key={index} selected={selectedValue(item, index)}>
                <Box className={classes.list}>
                  <Box className={classes.checkboxBox}>
                    <Checkbox
                      onChange={() => {
                        handleChange(item);
                      }}
                      checked={
                        !!value.find((product) => product.id === item.id)
                      }
                    />
                  </Box>
                  <Box className={classes.listImage}>
                    <img
                      src={item.picture ? item.picture : DefaultImg}
                      style={{ width: "30px", height: "30px" }}
                      alt={item.id}
                    />
                  </Box>
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="flex-start"
                    flexGrow={1}
                    style={{ minWidth: 0 }}
                  >
                    <Typography className={classes.name} variant="body2">
                      {item.name}
                    </Typography>
                    {!!item.attributes && !!item.attributes.length && (
                      <Typography
                        className={classes.attributeText}
                        variant="body2"
                      >
                        {item.attributes.join(", ")}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </ListItem>
            ))}
          </List>
        ) : (
          <Box py={9} style={{ textAlign: "center" }}>
            <Typography variant="body1">{emptyMessage}</Typography>
          </Box>
        )}
      </Box>
    </Popover>
  );
}
